var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2669 26.723V31.8673C36.2669 34.2978 34.2964 36.2669 31.8673 36.2669C29.4381 36.2669 27.4676 34.2964 27.4676 31.8673C27.4676 35.8267 25.742 39.3826 23.0014 41.8245C25.357 43.9238 28.4642 45.2007 31.8687 45.2007C39.2326 45.2007 45.2021 39.2312 45.2021 31.8673C45.2021 28.4628 43.9253 25.357 41.8259 23C40.3353 24.6732 38.4285 25.9671 36.2683 26.723",
    fill: "#FF3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2007 14.1342C45.2007 6.77032 39.2312 0.800781 31.8673 0.800781C28.4628 0.800781 25.357 2.07764 23 4.17696C25.7406 6.61885 27.4662 10.1748 27.4662 14.1342C27.4662 11.7037 29.4367 9.73457 31.8658 9.73457C34.295 9.73457 36.2655 11.7051 36.2655 14.1342V19.2785C38.4257 20.033 40.3311 21.3282 41.8231 23.0015C43.9224 20.6445 45.1993 17.5387 45.1993 14.1342H45.2007Z",
    fill: "#0051F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2669 19.2784V26.7244C38.4271 25.9699 40.3325 24.6747 41.8245 23.0014C40.3339 21.3282 38.4271 20.0344 36.2669 19.2784Z",
    fill: "#FF3B3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73309 19.2785V14.1342C9.73309 11.7037 11.7036 9.73457 14.1327 9.73457C16.5619 9.73457 18.5324 11.7051 18.5324 14.1342C18.5324 10.1748 20.2594 6.61885 22.9986 4.17696C20.6416 2.07764 17.5358 0.800781 14.1313 0.800781C6.76743 0.800781 0.79789 6.77032 0.79789 14.1342C0.79789 17.5387 2.07475 20.6445 4.17407 23.0015C5.66469 21.3282 7.57149 20.0344 9.73026 19.2785",
    fill: "#009991"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 4.177C20.2594 6.61889 18.5338 10.1749 18.5338 14.1343V18.6684H27.4676V14.1343C27.4676 10.1749 25.7406 6.61889 23.0014 4.177",
    fill: "#002AD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5338 31.8673C18.5338 34.2978 16.5633 36.2669 14.1342 36.2669C11.705 36.2669 9.73451 34.2964 9.73451 31.8673V26.723C7.57432 25.9685 5.66893 24.6732 4.1769 23C2.07758 25.357 0.80072 28.4628 0.80072 31.8673C0.80072 39.2312 6.77026 45.2007 14.1342 45.2007C17.5387 45.2007 20.6445 43.9238 23.0014 41.8245C20.2608 39.3826 18.5352 35.8267 18.5352 31.8673",
    fill: "#F7BD2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.723 27.4677H18.5338V31.8673C18.5338 35.8267 20.2594 39.3827 23 41.8246C25.7406 39.3827 27.4662 35.8267 27.4662 31.8673V27.4677H26.7216H26.723Z",
    fill: "#FF6631"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73309 26.7231V19.2771C7.5729 20.0316 5.66752 21.3269 4.1769 23.0001C5.66752 24.6733 7.57432 25.9672 9.73309 26.7231Z",
    fill: "#009991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomelogo);
export default __webpack_public_path__ + "static/media/homelogo.7328a9deeda3a888c90ec7231dcf1f78.svg";
export { ForwardRef as ReactComponent };